export {
  type GraphemeSimilarGrapheme,
  graphemeSimilarGraphemeTable,
} from "#grapheme-similar-grapheme-table";
